import React, { createContext, useContext, useState } from "react";

const AgentStatusContext = createContext();

export const AgentStatusProvider = ({ children }) => {
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const triggerStatusRefresh = () => {
        setRefreshTrigger((prev) => prev + 1);
    };

    return (
        <AgentStatusContext.Provider value={{ refreshTrigger, triggerStatusRefresh }}>
            {children}
        </AgentStatusContext.Provider>
    );
};

export const useAgentStatus = () => useContext(AgentStatusContext);
